<script setup>
import { computed } from 'vue';
import { Toast } from '@dashhudson/dashing-ui/toast';
import { useFilterSidePanel } from '@dashhudson/dashing-ui/filter-side-panel';

const { visible } = useFilterSidePanel();

const leftPadding = computed(() => (visible.value ? undefined : '84px'));
</script>

<template>
  <Toast :left-padding="leftPadding" />
</template>
